<template>
  <!-- 地图 -->
  <template v-if="displayStatus !== 'single'">
    <div class="mode-compare-box">
      <div class="mode-compare-map-box" :class="'mode-compare-map-box-' + modeCompareMapNum + 'map'">
        <div v-for="index in [...new Array(modeCompareMapNum).keys()]" class="mode-compare-map-box-single" :class="'mode-compare-map-box_' + index">
          <!-- 地图 -->
          <div :id="'mode-compare-map-' + index" class="mode-compare-map-box-single-item"></div>
          <!-- 常规 -->
          <div v-if="displayStatus !== 'multiLevel'" class="mode-compare-box-text-span mode-compare-box-mode-span">
            <span>{{ newMapList[index] ? newMapList[index].showText : "--" }}</span>
          </div>
          <div v-if="displayStatus !== 'multiLevel'" class="mode-compare-box-text-span mode-compare-box-date-span">
            <span>{{ newMapList[index] ?
              (newMapList[index].bottomShowText +
                ((heightSelectLevel !== undefined && newMapList[index].geoHeight) ? newMapList[index].geoHeight!.showText
                  : ""))
              : "--"
            }}</span>
          </div>
          <!-- 3D -->
          <div v-if="newMapList[index] && newMapList[index].is3D && threeModelOperation"
            class="mode-compare-three-dimension-control-panel">
            <span class="three-dimension-control-panel-text">剖面</span>
            <div class="three-dimension-control-panel-button-group">
              <el-popover placement="left" effect="dark" :teleported="false"
                popper-style="min-width: 0; width: none; padding-top: 2px; padding-bottom: 2px;">
                <template #reference>
                  <div class="three-dimension-control-panel-button">
                    <img src="./Icon/X.png" title="X轴截面" />
                  </div>
                </template>
                <el-slider v-model="threeModelOperation.xSectionVal" :range="true"
                  :min="parseFloat(threeModelOperation.xySectionInfo.xMin.toFixed(2))"
                  :max="parseFloat(threeModelOperation.xySectionInfo.xMax.toFixed(2))" style="width: 90px;"
                  :format-tooltip="(lng: number) => { return lng + '°E'; }" :step="0.01" @input="changeXSectionVal"
                  class="three-dimension-slider" />
              </el-popover>
              <el-popover placement="left" effect="dark" :teleported="false"
                popper-style="min-width: 0; width: none; padding-left: 2px; padding-right: 2px;">
                <template #reference>
                  <div class="three-dimension-control-panel-button">
                    <img src="./Icon/Y.png" title="Y轴截面" />
                  </div>
                </template>
                <el-slider v-model="threeModelOperation.ySectionVal" :range="true" vertical height="90px"
                  :min="parseFloat(threeModelOperation.xySectionInfo.yMin.toFixed(2))"
                  :max="parseFloat(threeModelOperation.xySectionInfo.yMax.toFixed(2))"
                  :format-tooltip="(lat: number) => { return lat + '°N'; }" :step="0.01" @input="changeYSectionVal"
                  class="three-dimension-slider-vertical" />
              </el-popover>
              <el-popover placement="left" effect="dark" :teleported="false"
                popper-style="min-width: 0; width: none; padding-left: 2px; padding-right: 2px;">
                <template #reference>
                  <div class="three-dimension-control-panel-button">
                    <img src="./Icon/Z.png" title="Z轴截面" />
                  </div>
                </template>
                <el-slider v-model="threeModelOperation.zSectionVal" :range="true" vertical height="90px"
                  :min="threeModelOperation.atmosphereInfo.min" :max="threeModelOperation.atmosphereInfo.max"
                  @input="changeZSectionVal" class="three-dimension-slider-vertical"
                  :format-tooltip="(pre: number) => { return (threeModelOperation!.atmosphereInfo.min + threeModelOperation!.atmosphereInfo.max - pre) + 'hPa'; }" />
              </el-popover>
              <div class="three-dimension-control-panel-button"
                :class="{ 'three-dimension-control-panel-button-select': isHeightCutting }"
                @click="switchHeightCutting">
                <span class="icon iconfont icon-duoceng" title="高度截面"></span>
              </div>
              <div class="three-dimension-control-panel-button" @click="drawHandle('draw_polygon')">
                <img src="./Icon/regionSelection.png" title="区域选取" />
              </div>
              <div class="three-dimension-control-panel-button" @click="drawHandle('draw_line_string')">
                <img src="./Icon/lineSelection.png" title="截面选取" />
              </div>
              <div class="three-dimension-control-panel-button" @click="trashHandle()">
                <img src="./Icon/trash.png" title="移除" />
              </div>
            </div>
            <span class="three-dimension-control-panel-text">透明度</span>
            <el-slider v-model="threeModelOperation.opacityVal" vertical :min="0" :max="1" :step="0.01" height="80px"
              @input="changeOpacity" class="three-dimension-slider-vertical" />
            <span class="three-dimension-control-panel-text">阈值</span>
            <el-slider v-model="threeModelOperation.thresholdVal" vertical :min="threeModelOperation.thresholdInfo.min"
              :max="threeModelOperation.thresholdInfo.max" height="80px" @input="change3DThreshold"
              class="three-dimension-slider-vertical" />
          </div>
          <!-- 高度层 -->
          <div v-if="newMapList[index] && newMapList[index].level"
            class="mode-compare-three-dimension-level-panel custo-el-select">
            <template v-if="displayStatus === 'multiLevel'">
              <el-select @change="changeLevel(index)" v-model="newMapList[index].level">
                <el-option v-for="height in heightOption" :key="height" :value="height"
                  :label="height + 'hPa'"></el-option>
              </el-select>
              <div class="mode-compare-box-text-color-box">
                <el-slider v-if="newMapList[index] && newMapList[index].colorThresholder" :step="0.01"
                  :max="(newMapList[index].colorThresholder!.length - 1) * 10"
                  :format-tooltip="newMapList[index].colorThresholder!.mappingFuncWithUnit"
                  v-model="newMapList[index].colorThresholder!.threshold"
                  @input="changeThreshold(index, newMapList[index].colorThresholder!.threshold)" />
                <div v-if="newMapList[index] && newMapList[index].colorThresholder"
                  class="mode-compare-box-text-color-threshold-text"
                  v-for="(value, thresholdIndex) in newMapList[index].colorThresholder?.valueList"
                  :style="{ left: thresholdIndex * (360 / (newMapList[index].colorThresholder!.length - 1)) + 'px' }">
                  {{ parseFloat(value).toFixed(1) }}
                </div>
                <canvas :id="'mode-compare-map-' + index + '-color'" height="20" width="360">
                </canvas>
              </div>
            </template>
            <template v-if="displayStatus === 'multiElement'">
              <div class="mode-compare-box-multiElement-text-color-box">
                <el-slider v-if="newMapList[index] && newMapList[index].colorThresholder" :step="0.01" vertical
                  :max="(newMapList[index].colorThresholder!.length - 1) * 10"
                  :format-tooltip="newMapList[index].colorThresholder!.mappingFuncWithUnit"
                  v-model="newMapList[index].colorThresholder!.threshold"
                  @input="changeThreshold(index, newMapList[index].colorThresholder!.threshold)" />
                <div v-if="newMapList[index] && newMapList[index].colorThresholder"
                  class="mode-compare-box-color-threshold-text"
                  v-for="(value, thresholdIndex) in newMapList[index].colorThresholder?.valueList"
                  :style="{ top: (360 - thresholdIndex * (360 / (newMapList[index].colorThresholder!.length - 1))) + 'px' }">
                  {{ parseFloat(value).toFixed(1) }}
                </div>
                <canvas :id="'mode-compare-map-' + index + '-color'" height="360" width="20">
                </canvas>
              </div>
            </template>
          </div>
          <!-- 多要素 -->
          <div v-if="displayStatus === 'multiElement' && ColorBarDataList[index]" class="mode-compare-box-color-bar">
            <template v-if="ColorBarDataList[index].colorOpacity.length > 20">
              <div class="split-color-bar-color-box">
                <div v-for="splitCodeColor in ColorBarDataList[index].codeColor" class="split-color-bar-color-box-item">
                  <div v-for="item in splitCodeColor" class="color-item" :style="{ background: item }"></div>
                </div>
              </div>
              <div class="split-color-code-options">
                <div v-for="(splitCodeKeys, splitIndex) in ColorBarDataList[index].codeKeys"
                  class="split-color-code-options-item">
                  <div v-for="(item, idx) in splitCodeKeys" class="color-code-item">
                    <el-popover placement="left" :width="200" :hide-after="0">
                      <template #reference>
                        <span>{{ item }}</span>
                      </template>
                      <el-slider v-model="ColorBarDataList[index].colorOpacity[splitIndex * 20 + idx]" :max="1"
                        :step="0.01" size="small"
                        @change="changeSpecitfiedOpacity(idx, ColorBarDataList[index].colorOpacity[splitIndex * 20 + idx], index)" />
                    </el-popover>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="color-bar-color-box">
                <div v-for="item in ColorBarDataList[index].codeColor" class="color-item"
                  :style="{ background: item as string }"></div>
              </div>
              <div class="color-code-options">
                <div v-for="(item, idx) in ColorBarDataList[index].codeKeys" class="color-code-item"
                  :style="{ height: (ColorBarDataList[index].codeKeys.length > 39 ? (780 / ColorBarDataList[index].codeKeys.length) : 20) + 'px' }">

                  <el-popover placement="left" :width="200" :hide-after="0">
                    <template #reference>
                      <span>{{ item }}</span>
                    </template>
                    <!-- change todo -->
                    <el-slider v-model="ColorBarDataList[index].colorOpacity[idx]" :max="1" :step="0.01" size="small"
                      @change="changeSpecitfiedOpacity(idx, ColorBarDataList[index].colorOpacity[idx])" />
                  </el-popover>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
  </template>
  <div v-if="ColorBarData && displayStatus !== 'multiElement'" class="color-bar-box"
    :class="{ 'color-bar-box-split-screen': displayStatus !== 'single' }">
    <div class="color-bar-color-box">
      <div v-for="item in ColorBarData.codeColor" :style="{ background: item as string }"></div>
    </div>
    <div class="color-code-options">
      <div v-for="(item, index) in ColorBarData.codeKeys"
        :style="{ height: (ColorBarData.codeKeys.length > 39 ? (780 / ColorBarData.codeKeys.length) : 20) + 'px' }">
        <el-popover placement="left" :width="200" :hide-after="0">
          <template #reference>
            <span>{{ ColorBarData.windLabels ? ColorBarData.windLabels[index] : item }}</span>
          </template>
          <el-slider v-model="ColorBarData.colorOpacity[index]" :max="1" :step="0.01" size="small"
            @change="changeSpecitfiedOpacity(index, ColorBarData.colorOpacity[index])" />
        </el-popover>
        <span class="float-wind-text" v-if="ColorBarData.windLabels && index !== 0">{{ item }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts" name="ModeCompare">
import { ref, onMounted, nextTick, onUnmounted, toRefs, watch } from "vue";
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css';
import { $Self } from "@/EventsBus";
import CustomLayer from "erayic-com-pack/encapsulation/layers/singleCustomLayer";
import { $Bus } from "erayic-com-pack/EventBus";
import { ElMessage } from "element-plus";
import * as ModeCompare from "./ModeCompare";
import { I_FactsColorBarItem, MapProps, NewMapListItem, ThreeModelOperation } from "./ModeComapare.type";
import { ModeCompareEvents } from "@/EventsBus/Apply/ModeCompareEvents";
import GrayImage, { GetBytesFromImage, GrayImageByValue, SpecificWindColor, atmosphericPressure_to_height } from "erayic-com-pack/encapsulation/composables/useColorMap";
import { ClassThreeTextureModel } from "erayic-com-pack/component/ThreeScene/TextureModelClass";
import MapboxDraw from "@mapbox/mapbox-gl-draw";
import { TextureEvents } from "erayic-com-pack/EventBus/Map/TextureEvents";
import { DateAdd, timeToString } from "erayic-com-pack/utils/timerToString";
import { calcSliceUrl, getSliceGridArray } from "erayic-com-pack/component/NewMap/NewMapLayer/SliceTextureLayer";
import singleCustomLayer from "erayic-com-pack/encapsulation/layers/singleCustomLayer";
import { loadImage, geojsonClip } from "../../views/SecondaryMenuList/ModelForecast/ModeForecast";

const props = defineProps<{ linearFillColor: boolean, heightSelectLevel: number | undefined, gridData: boolean, gridWind: boolean, flowLineDisplay: boolean, maskDisplay: boolean }>();
/** linearFillColor: 渐变填色状态; heightSelectLevel: 位势高度场状态, gridData: 格点状态, gridWind: 风羽状态, flowLineDisplay: 流线状态, maskDisplay: 遮罩状态  */
const { linearFillColor, heightSelectLevel, gridData, gridWind, flowLineDisplay, maskDisplay } = toRefs(props);

/** 展示状态 */
const displayStatus = ref<"single" | "compare" | "multiLevel" | "adjust" | "multiTime" | "multiElement" | "difference">("single");
/** 地图对象数组 */
const newMapList = ref<NewMapListItem[]>([]);
/** 地图默认属性 */
const mapProps = ref<MapProps>({ center: new mapboxgl.LngLat(109, 19), zoom: 6.5, pitch: 0, bearing: 0 });
/** 高度层可选项 */
const heightOption = ref();
/** 三维裁切绘制绑定变量 */
const mapboxDraw = ref(new MapboxDraw(ModeCompare.mapboxDrawParams));
/** 模式对比下的地图数量 */
const modeCompareMapNum = ref<number>(4);
/** 色标绑定对象 */
const colorThresholder = ref<{
  /** 阈值 */
  threshold: number,
  /** 色标长度(个) */
  length: number,
  /** 映射函数 */
  mappingFunc: (val: number) => number,
  /** 映射函数(带单位) */
  mappingFuncWithUnit: (val: number) => string,
  /** 色标值数组 */
  valueList: string[]
}>();
/** 高度截面状态 */
const isHeightCutting = ref<boolean>(false);

/** 透明度 */
const specifiedAlpha = ref<{ index: number, alpha: number }[]>([]);
/** 色标数组 */
const ColorBarData = ref<I_FactsColorBarItem>();
/** 多要素下的色标数组 */
const ColorBarDataList = ref<I_FactsColorBarItem[]>([]);

defineExpose({ ColorBarData });

onMounted(() => {
  $Bus.MapEvent.Texture.on('SliceTextureRenderingCompleted', TextureRenderingCompletedHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenHandle", SplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.on("ExitSplitScreen", ExitSplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenHeightField", SplitScreenHeightFieldHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenWindField", SplitScreenWindFieldHandle);
  $Self.ApplyEvents.ModeCompare.on("SplitScreenPositionSet", SplitScreenPositionSetHandle);
});

onUnmounted(() => {
  newMapList.value.forEach(item => { if (item.map) item.map.remove() });
  $Bus.MapEvent.Texture.off('SliceTextureRenderingCompleted', TextureRenderingCompletedHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenHandle", SplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.off("ExitSplitScreen", ExitSplitScreenHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenHeightField", SplitScreenHeightFieldHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenWindField", SplitScreenWindFieldHandle);
  $Self.ApplyEvents.ModeCompare.off("SplitScreenPositionSet", SplitScreenPositionSetHandle);
});

// 监听状态改变
// 填色
watch(linearFillColor, (value) => {
  newMapList.value.forEach((item) => {
    item.sliceLayer.forEach((layer) => layer.changeVisualEffect(value ? 1 : 0));
  });
});
// 位势高度
watch(heightSelectLevel, (value) => {
  newMapList.value.forEach((item) => {
    if (item.map.getLayer("geoHeightLine"))
      item.map.setLayoutProperty("geoHeightLine", "visibility", value !== undefined ? "visible" : "none");
    if (item.map.getLayer("geoHeightText"))
      item.map.setLayoutProperty("geoHeightText", "visibility", value !== undefined ? "visible" : "none");
  });
});
// 格点
watch(gridData, (value) => {
  newMapList.value.forEach((item) => {
    if (value) refreshGrid(item.map, item.sliceLayer as singleCustomLayer[]);
    else {
      const source = item.map.getSource("GridDataSource");
      if (source) (source as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
    }
  });
});
// 风场
watch(gridWind, (value) => {
  newMapList.value.forEach((item, index) => {
    if (value) refreshWindField(item.map, index);
    else {
      const source = item.map.getSource("GridWindSource");
      if (source) (source as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
    }
  });
});
// 流线
watch(flowLineDisplay, (value) => {

});
// 遮罩状态
watch(maskDisplay, (value) => {
  MaskDisplayHandle(value);
});

// 修改遮罩显示状态
const MaskDisplayHandle = (tag: boolean) => {
  newMapList.value.forEach((item, index) => {
    if (gridData.value) refreshGrid(item.map, item.sliceLayer as singleCustomLayer[]);
    if (gridWind.value) refreshWindField(item.map, index);
  });

  newMapList.value.forEach(async (item) => {
    item.sliceLayer.forEach((layer) => { layer.changeMask(tag); });

    if (item.geoHeight && item.geoHeight.origin) {
      if (tag) {
        if (!item.geoHeight.clip) item.geoHeight.clip = await geojsonClip(item.geoHeight.origin, "IntelligentGrid");
        if (item.map.getSource("geoHeightSource"))
          (item.map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData(item.geoHeight.clip);
      } else if (item.map.getSource("geoHeightSource"))
        (item.map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData(item.geoHeight.origin);
    }
  });
};

// 风力等级固定值 用于在风力色标的特殊处理
const FixedWindLables = ["0", "5.5", "8", "10.8", "13.9", "17.2", "20.8", "24.5", "28.5", "32.7", "37", "41.5", "46.2", "51", "56.1"];
const FixedWindScale = ["≤3", "4", "5", "6", "7", "8", "9", "10", "11", "12", "13", "14", "15", "16", "≥17"];
const WindyWindLabels = ["0", "1", "3", "5", "7", "9", "11", "13", "15", "17", "19", "21", "24", "27", "29", "36", "46", "51", "77", "104"];

const isWindyWindLayer = (layerId: string, unit: string) => {
  if (unit !== "m/s") return false;
  return /_(UV|WS12|GUST)_/.test(layerId);
};

const getColorBarDisplayData = (layerId: string, colorCodeData: { [key: string]: string }, unit: string) => {
  if (isWindyWindLayer(layerId, unit)) {
    return {
      codeKeys: WindyWindLabels,
      codeColor: WindyWindLabels.map((item) => SpecificWindColor[item as unknown as keyof typeof SpecificWindColor]),
      windLabels: undefined
    };
  }

  const codeLabels = Object.keys(colorCodeData).sort((a: string, b: string) => parseFloat(a) - parseFloat(b));
  const codeValues: string[] = [];
  codeLabels.forEach(item => { codeValues.push(colorCodeData[item]) });
  codeLabels.forEach((item, index) => {
    const num = parseFloat(item);
    if (!isNaN(num)) {
      const tempNum = parseFloat(num.toFixed(1));
      codeLabels[index] = tempNum % 1 === 0 ? tempNum.toFixed(0) : tempNum.toString();
    }
  });

  let windLabels: string[] | undefined;
  if (unit === "m/s") {
    let index = 0;
    while (index < codeLabels.length) {
      if (codeLabels[index] === FixedWindLables[index]) index++;
      else break;
    }
    if (index === codeLabels.length) windLabels = FixedWindScale;
  }

  return { codeKeys: codeLabels, codeColor: codeValues, windLabels };
};

function TextureRenderingCompletedHandle(params: TextureEvents["SliceTextureRenderingCompleted"]) {
  if (displayStatus.value === "single" && params.LayerId !== ColorBarData.value?.id) {
    const displayData = getColorBarDisplayData(params.LayerId, params.ColorCodeData, params.Unit);
    ColorBarData.value = {
      id: params.LayerId, codeKeys: displayData.codeKeys, codeColor: displayData.codeColor, colorOpacity: Array.from({ length: displayData.codeColor.length }, () => 1),
      unit: params.Unit, windLabels: displayData.windLabels
    };
  }
}

/** 监听绘制多分屏 */
const SplitScreenHandle = (params: ModeCompareEvents["SplitScreenHandle"]) => {
  displayStatus.value = params.display;
  const refreshTag = modeCompareMapNum.value === params.list.length || (params.list.length > 4 && modeCompareMapNum.value > 4); // 不触发resize情况下需要手动refreshSliceLayer
  modeCompareMapNum.value = params.list.length;

  // 已有地图组件
  if (newMapList.value.length) {
    // 移除多余地图
    if (newMapList.value.length > params.list.length) {
      for (let i = newMapList.value.length - 1; i >= params.list.length; i--) {
        newMapList.value[i].map.remove();
        newMapList.value.splice(i, 1);
      }
    }

    // 更新已有地图的信息  无需在此refreshSliceLayer 在之后的所有已有地图的resize中会触发moveend更新切片图层
    newMapList.value.forEach((item, i) => {
      if (item.sliceInfo.URL !== params.list[i].url) {
        item.sliceInfo = { URL: params.list[i].url, texClipParams: params.list[i].texClipParams, isNearest: params.isNearest };
        item.showText = (`${params.list[i].mode} -- ${timeToString(new Date(params.list[i].dataDate), "yyyy-MM-dd HH:00")} +` +
          (params.list[i].fcstDateScale < 10 ? "00" : (params.list[i].fcstDateScale < 100 ? "0" : "")) + params.list[i].fcstDateScale +
          `H(${timeToString(DateAdd("h", params.list[i].fcstDateScale, new Date(params.list[i].dataDate)), "ddHH")})`);
        item.bottomShowText = `${params.list[i].ele}(阴影)，${params.list[i].ele}(格点)`;
      }

      if (refreshTag) refreshSliceLayer({ target: newMapList.value[i].map }, i, displayStatus.value !== "multiElement" ? params.updateColorBar : true);
    });

    nextTick(async () => {
      for (let i = 0; i < newMapList.value.length; i++) newMapList.value[i].map.resize(); // 更新地图样式 触发refreshSliceLayer

      // 新增所需地图
      if (newMapList.value.length < params.list.length)
        for (let i = newMapList.value.length; i < params.list.length; i++)
          await ModeCompare.InitializeMap("mode-compare-map-" + i, mapProps).then((map) => {
            newMapList.value?.push({
              map, markerInfo: {}, sliceLayer: [], usedTexChannel: new Array(16).fill(false),
              sliceInfo: { URL: params.list[i].url, texClipParams: params.list[i].texClipParams, isNearest: params.isNearest },
              showText: (`${params.list[i].mode} -- ${timeToString(new Date(params.list[i].dataDate), "yyyy-MM-dd HH:00")} +` +
                (params.list[i].fcstDateScale < 10 ? "00" : (params.list[i].fcstDateScale < 100 ? "0" : "")) + params.list[i].fcstDateScale +
                `H(${timeToString(DateAdd("h", params.list[i].fcstDateScale, new Date(params.list[i].dataDate)), "ddHH")})`),
              bottomShowText: `${params.list[i].ele}(阴影)，${params.list[i].ele}(格点)`, windImage: []
            });

            // const markerDiv = document.createElement('div');
            // markerDiv.className = "ModeCompareMapMarker";
            // const marker = new mapboxgl.Marker(markerDiv).setLngLat([0, 0]).setOffset([45, 23]);
            // newMapList.value?.push({ map, markerInfo: { marker, markerDiv } });

            map.on("moveend", (e) => moveendHandle(e, i));
            map.on("load", () => {
              newMapList.value[i].map.on("moveend", (e) => refreshSliceLayer(e, i));
              refreshSliceLayer({ target: newMapList.value[i].map }, i, displayStatus.value !== "multiElement" ? params.updateColorBar : true);
            });
          });
    });
  } else // new 地图组件
    nextTick(() => {
      [...(new Array(modeCompareMapNum.value).keys())].forEach(async i => {
        ModeCompare.InitializeMap("mode-compare-map-" + i, mapProps).then((map) => {
          newMapList.value?.push({
            map, markerInfo: {}, sliceLayer: [], usedTexChannel: new Array(16).fill(false),
            sliceInfo: { URL: params.list[i].url, texClipParams: params.list[i].texClipParams, isNearest: params.isNearest },
            showText: (`${params.list[i].mode} -- ${timeToString(new Date(params.list[i].dataDate), "yyyy-MM-dd HH:00")} +` +
              (params.list[i].fcstDateScale < 10 ? "00" : (params.list[i].fcstDateScale < 100 ? "0" : "")) + params.list[i].fcstDateScale +
              `H(${timeToString(DateAdd("h", params.list[i].fcstDateScale, new Date(params.list[i].dataDate)), "ddHH")})`),
            bottomShowText: `${params.list[i].ele}(阴影)，${params.list[i].ele}(格点)`, windImage: []
          });

          // const markerDiv = document.createElement('div');
          // markerDiv.className = "ModeCompareMapMarker";
          // const marker = new mapboxgl.Marker(markerDiv).setLngLat([0, 0]).setOffset([45, 23]);
          // newMapList.value?.push({ map, markerInfo: { marker, markerDiv } });

          map.on("moveend", (e) => moveendHandle(e, i));
          map.on("load", () => {
            newMapList.value[i].map.on("moveend", (e) => refreshSliceLayer(e, i));
            refreshSliceLayer({ target: newMapList.value[i].map }, i, displayStatus.value !== "multiElement" ? params.updateColorBar : true);
          });
        });
      });
    });

  function moveendHandle(e: mapboxgl.MapboxEvent<MouseEvent | TouchEvent | WheelEvent | undefined> & mapboxgl.EventData, i: number) {
    if (e.originalEvent) {
      mapProps.value = { center: e.target.getCenter(), zoom: e.target.getZoom(), bearing: e.target.getBearing(), pitch: e.target.getPitch() };
      transformHandle(i, mapProps.value);
    }

    function transformHandle(self: number, params: { zoom: number, center: mapboxgl.LngLat, bearing: number, pitch: number }) {
      if (newMapList.value)
        newMapList.value.forEach((item, index) => {
          if (index !== self && !item.is3D) item.map.flyTo({
            center: params.center, zoom: params.zoom, bearing: params.bearing, pitch: params.pitch, speed: 2, easing: t => t
          });
        });
    }
  }
};

// 加载/更新格点
async function refreshGrid(map: mapboxgl.Map, currentLayer: singleCustomLayer[]) {
  const imageList: (GrayImage | GrayImageByValue)[] = [];
  for (let i = 0; i < currentLayer.length; i++)
    if (currentLayer[i] && currentLayer[i].image) imageList.push(currentLayer[i].image!);
  if (!imageList.length) return;

  const northeast = map.getBounds().getNorthEast();
  const southwest = map.getBounds().getSouthWest();

  let minLon: number = southwest.lng, maxLon: number = northeast.lng,
    minLat: number = southwest.lat, maxLat: number = northeast.lat;

  if (maskDisplay.value) {
    maxLon = maxLon > 120.35 ? 120.35 : maxLon;
    minLon = minLon < 106.1 ? 106.1 : minLon;
    maxLat = maxLat > 25 ? 25 : maxLat;
    minLat = minLat < 1.3 ? 1.3 : minLat;
  } else {
    maxLon = maxLon > 180 ? 180 : maxLon;
    minLon = minLon < 0 ? 0 : minLon;
    maxLat = maxLat > 90 ? 90 : maxLat;
    minLat = minLat < 0 ? 0 : minLat;
  }

  const leftUp = map.project([minLon, maxLat]);
  const rightDown = map.project([maxLon, minLat]);

  const FeatureCollection: GeoJSON.FeatureCollection<GeoJSON.Point, GeoJSON.GeoJsonProperties> = {
    type: "FeatureCollection",
    features: await getSliceGridArray({ minLat, maxLat, minLon, maxLon }, leftUp, rightDown, imageList[0].yInterval, imageList[0].xInterval,
      1000, imageList, false)
  };

  if (!map.getSource("GridDataSource")) {
    map.addSource("GridDataSource", { type: "geojson", data: FeatureCollection });
    map.addLayer({
      id: "GridDataLayer", source: "GridDataSource", type: "symbol",
      paint: { "text-color": "black", "text-halo-color": "white", "text-halo-width": 1 },
      layout: { "text-field": ["coalesce", ["get", "value"], ''], "text-size": 12, "text-allow-overlap": true }
    });
  } else
    (map.getSource("GridDataSource") as mapboxgl.GeoJSONSource).setData(FeatureCollection);
}

/** 监听绘制位势高度图层 */
const SplitScreenHeightFieldHandle = async (params: ModeCompareEvents["SplitScreenHeightField"]) => {
  const tag = newMapList.value.length !== params.length ? await waitForNonEmptyArray(newMapList.value, params.length) : true;
  if (tag)
    params.forEach((item, index) => {
      if (item.url.length)
        fetch(item.url).then(response => response.json()).then(async data => {
          // 500hPa 588标红
          if (item.height === 500) data.features.forEach((item: { [key: string]: any }) => {
            if (item.properties && item.properties.value === 588) {
              item.properties.color = "#FF0000";
              item.properties.lineWidth = 4;
            }
          });

          let drawData = data;
          newMapList.value[index].geoHeight = {
            url: item.url, height: item.height, showText: "，" + (item.height === 0 ? "海平面气压等值线" : (item.height + "hPa高度等值线")), origin: drawData
          };
          if (maskDisplay.value) {
            newMapList.value[index].geoHeight!.clip = await geojsonClip(data, "IntelligentGrid");
            drawData = newMapList.value[index].geoHeight!.clip;
          }

          if (newMapList.value[index].map.getSource("geoHeightSource"))
            (newMapList.value[index].map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData(drawData);
          else {
            newMapList.value[index].map.addSource("geoHeightSource", { type: "geojson", data: drawData });
            newMapList.value[index].map.addLayer({
              id: "geoHeightLine", type: "line", source: "geoHeightSource", layout: { visibility: heightSelectLevel.value !== undefined ? "visible" : "none" },
              paint: { "line-color": ["coalesce", ["get", "color"], '#0000FF'], "line-width": ["coalesce", ["get", "lineWidth"], 2] }
            });
            newMapList.value[index].map.addLayer({
              id: "geoHeightText", type: "symbol", source: "geoHeightSource",
              paint: { "text-color": ["coalesce", ["get", "color"], '#0000FF'], "text-halo-color": "white", "text-halo-width": 2 },
              layout: {
                visibility: heightSelectLevel.value !== undefined ? "visible" : "none", "symbol-placement": "line",
                "text-allow-overlap": true, "symbol-spacing": 500, "text-field": ["coalesce", ["get", "value"], '']
              }
            });
          }
        }).catch(error => {
          if (newMapList.value[index].map.getSource("geoHeightSource"))
            (newMapList.value[index].map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
        });
      else if (newMapList.value[index].map.getSource("geoHeightSource"))
        (newMapList.value[index].map.getSource("geoHeightSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] });
    });
};

/** 监听绘制风场图层 */
const SplitScreenWindFieldHandle = async (params: ModeCompareEvents["SplitScreenWindField"]) => {
  const tag = newMapList.value.length !== params.length ? await waitForNonEmptyArray(newMapList.value, params.length) : true;
  if (tag)
    params.forEach((item, index) => {
      newMapList.value[index].windHeight = item;
      if (gridWind.value) refreshWindField(newMapList.value[index].map, index);
    });
};

// 轮询等待
async function waitForNonEmptyArray<T>(array: T[], tagLength: number): Promise<boolean> {
  let tag = 0;
  while (true) {
    if (array.length === tagLength) return true; // 数组有长度，返回成功
    if (tag >= 10) return false; // 超时，返回失败
    tag++;
    await new Promise(resolve => setTimeout(resolve, 100));
  }
}

/** 监听设置地图位置 */
const SplitScreenPositionSetHandle = (params: ModeCompareEvents["SplitScreenPositionSet"]) => {
  mapProps.value.center = new mapboxgl.LngLat(params.position[0], params.position[1]);
  mapProps.value.zoom = params.zoom - 1;
  newMapList.value.forEach((item) => {
    item.map.flyTo({ center: params.position, zoom: params.zoom - 1 });
  });
};

/** 移除多分屏 */
const ExitSplitScreenHandle = () => {
  newMapList.value.forEach(item => { if (item.map) item.map.remove() });
  newMapList.value = [];
  displayStatus.value = "single";
};

/** 
 * 指定地图绘制切片纹理图
 * @param index 地图索引
 */
// firstRender: 初次渲染完成后抛出消息
async function refreshSliceLayer(e: { target: mapboxgl.Map }, index: number, updateColorBar?: boolean) {
  const params = newMapList.value[index].sliceInfo;
  const map = e.target;
  const urlList = (params.texClipParams.coeffX && params.texClipParams.coeffX.length) ?
    calcSliceUrl(map, params.URL, params.texClipParams) : [params.URL.replace("{level}", "0").replace("{index}", "0")]; // 特殊处理 仅1级的时候

  // 初始化状态
  const statusParams: { visualEffect: number, isNearest?: boolean, mask?: boolean } = { visualEffect: linearFillColor.value ? 1 : 0, mask: maskDisplay.value ?? undefined };
  if (params.isNearest !== undefined) statusParams.isNearest = params.isNearest;

  const tempCurrentLayer: singleCustomLayer[] = [];
  let layerLoadFinishCounter: number = 0; // 图层加载完成 计数器
  urlList.forEach((url) => {
    let tag = false;
    for (let i = 0; i < newMapList.value[index].sliceLayer.length; i++) {
      if (newMapList.value[index].sliceLayer[i].id === url) {
        tempCurrentLayer.push(newMapList.value[index].sliceLayer[i] as singleCustomLayer);
        layerLoadFinishCounter++;
        if (gridData.value && urlList.length === layerLoadFinishCounter) refreshGrid(map, tempCurrentLayer);
        tag = true;
        break;
      }
    }

    if (!tag) { // 新增
      const idx = newMapList.value[index].usedTexChannel.findIndex((item) => item === false);
      newMapList.value[index].usedTexChannel[idx] = true;
      const webglProperties = new singleCustomLayer(url, url, "splitScreenSliceLayer", [idx + 1], () => {
        if (specifiedAlpha.value.length) // 初始化透明度
          specifiedAlpha.value.forEach((item) => {
            webglProperties.changeSpecifiedOpacity(item.index, item.alpha);
          });
        layerLoadFinishCounter++;
        if (gridData.value && urlList.length === layerLoadFinishCounter) refreshGrid(map, tempCurrentLayer);

        // 更新色标
        if (updateColorBar && webglProperties.image) {
          const splitId = webglProperties.id.split("/");
          const splitIdIdx = splitId.findIndex(item => item === "TUM_SLICE");
          const ColorBarDataId = splitIdIdx !== -1 ? `${splitId[splitIdIdx]}_${splitId[splitIdIdx + 2]}` : "";

          if (displayStatus.value !== "multiElement") {
            if (!ColorBarData.value || ColorBarDataId !== ColorBarData.value.id) {
              const displayData = getColorBarDisplayData(ColorBarDataId, webglProperties.image.colorCodeData, webglProperties.image.dataUnit);
              ColorBarData.value = {
                id: ColorBarDataId,
                codeKeys: displayData.codeKeys,
                codeColor: displayData.codeColor,
                colorOpacity: Array.from({ length: displayData.codeColor.length }, () => 1),
                unit: webglProperties.image.dataUnit,
                windLabels: displayData.windLabels
              };
            }
          } else {
            const displayData = getColorBarDisplayData(ColorBarDataId, webglProperties.image.colorCodeData, webglProperties.image.dataUnit);
            const codeLabels = displayData.codeKeys as string[];
            const codeValues = displayData.codeColor as string[];

            if (codeValues.length > 20) {
              const splitCodeValues = [], splitCodeLabels = [];
              for (let i = codeValues.length; i > 0; i -= 20) {
                const start = Math.max(0, i - 20);
                splitCodeValues.unshift(codeValues.slice(start, i));
                splitCodeLabels.unshift(codeLabels.slice(start, i));
              }
              ColorBarDataList.value[index] = {
                id: ColorBarDataId, codeKeys: splitCodeLabels, codeColor: splitCodeValues, colorOpacity: Array.from({ length: codeValues.length }, () => 1), unit: webglProperties.image.dataUnit
              };
            } else
              ColorBarDataList.value[index] = {
                id: ColorBarDataId, codeKeys: codeLabels, codeColor: codeValues, colorOpacity: Array.from({ length: codeValues.length }, () => 1), unit: webglProperties.image.dataUnit
              };
          }
        }
      }, statusParams, false);
      map.addLayer(webglProperties, "world_line");
      tempCurrentLayer.push(webglProperties);
    }
  });

  // 移除
  setTimeout(() => {
    newMapList.value[index].sliceLayer.forEach((item) => {
      if (!urlList.includes(item.id)) {
        map.removeLayer(item.id);
        newMapList.value[index].usedTexChannel[item.textureChannel[0] - 1] = false;
      }
    });
    newMapList.value[index].sliceLayer = tempCurrentLayer;
  }, 100);

  // 风场
  if (gridWind.value && newMapList.value[index].windHeight)
    refreshWindField(map, index);
}

/** 刷新风场 */
const refreshWindField = async (map: mapboxgl.Map, index: number) => {
  const windParams = newMapList.value[index].windHeight!;
  const windUrlList = (windParams.texClipParams.coeffX && windParams.texClipParams.coeffX.length) ?
    calcSliceUrl(map, windParams.url, windParams.texClipParams as { coeffX: number[], coeffY: number[] },
      maskDisplay.value ? { minLat: 1.3, maxLat: 25, minLng: 106.1, maxLng: 120.35 } : undefined) :
    [windParams.url.replace("{level}", "0").replace("{index}", "0")]; // 特殊处理 仅1级的时候
  for (let i = 0; i < windUrlList.length; i++) windUrlList[i] = windUrlList[i].replace("{height}", windParams.height.toString());

  const tempWindImage: NewMapListItem["windImage"] = [];
  try {
    for (let windIndex = 0; windIndex < windUrlList.length; windIndex++) {
      let tag = false;

      for (let i = 0; i < newMapList.value[index].windImage.length; i++)
        if (newMapList.value[index].windImage[i].url === windUrlList[windIndex]) {
          tempWindImage.push(newMapList.value[index].windImage[i] as { image: GrayImage, url: string });
          tag = true;
          break;
        }

      if (!tag) {
        const image = await loadImage(windUrlList[windIndex]);
        tempWindImage.push({ image, url: windUrlList[windIndex] });
      }
    }
    newMapList.value[index].windImage = tempWindImage;
    const res = await generateWindFeature(map, tempWindImage, newMapList.value[index].windHeight!.height);

    if (!map.getSource("GridWindSource")) {
      map.addSource("GridWindSource", { type: "geojson", data: res });
      map.addLayer({
        id: "GridWindLayer", source: "GridWindSource", type: "symbol",
        layout: { "icon-image": ['coalesce', ['get', 'imgKey'], ''], "icon-rotate": ['coalesce', ['get', 'rotate'], 0], "icon-allow-overlap": true }
      });
    } else
      (map.getSource("GridWindSource") as mapboxgl.GeoJSONSource).setData(res);
  } catch (error) { // 图片加载失败
    if (map.getSource("GridWindSource"))
      (map.getSource("GridWindSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] }); // 清空风场
  }

  // 生成风场格点feature
  async function generateWindFeature(map: mapboxgl.Map, tempWindImage: NewMapListItem["windImage"], level: number): Promise<GeoJSON.FeatureCollection<GeoJSON.Point, GeoJSON.GeoJsonProperties>> {
    const imageList: GrayImage[] = [];
    for (let i = 0; i < tempWindImage.length; i++)
      if (tempWindImage[i] && tempWindImage[i].image) imageList.push(tempWindImage[i].image!);
    if (!imageList.length) (map.getSource("GridWindSource") as mapboxgl.GeoJSONSource).setData({ type: "FeatureCollection", features: [] }); // 清空风场

    const northeast = map.getBounds().getNorthEast();
    const southwest = map.getBounds().getSouthWest();

    let minLon: number = southwest.lng, maxLon: number = northeast.lng,
      minLat: number = southwest.lat, maxLat: number = northeast.lat;

    if (maskDisplay.value) {
      maxLon = maxLon > 120.35 ? 120.35 : maxLon;
      minLon = minLon < 106.1 ? 106.1 : minLon;
      maxLat = maxLat > 25 ? 25 : maxLat;
      minLat = minLat < 1.3 ? 1.3 : minLat;
    } else {
      maxLon = maxLon > 180 ? 180 : maxLon;
      minLon = minLon < 0 ? 0 : minLon;
      maxLat = maxLat > 90 ? 90 : maxLat;
      minLat = minLat < 0 ? 0 : minLat;
    }


    const leftUp = map.project([minLon, maxLat]);
    const rightDown = map.project([maxLon, minLat]);
    return {
      type: "FeatureCollection", features: await getSliceGridArray({ minLat, maxLat, minLon, maxLon }, leftUp, rightDown,
        imageList[0].yInterval, imageList[0].xInterval, level, imageList, true)
    };
  }
}

// 修改指定色标的透明度
const changeSpecitfiedOpacity = (index: number, value: number, mapIndex?: number) => {
  if (displayStatus.value === "single")
    $Self.ApplyEvents.ModeCompare.emit("ChangeSpecifiedOpacity", { index, alpha: value });
  else {
    if (mapIndex === undefined)
      newMapList.value.forEach((item) => {
        item.sliceLayer.forEach((layer) => layer.changeSpecifiedOpacity(index, value));
      });
    else newMapList.value[mapIndex].sliceLayer.forEach((layer) => layer.changeSpecifiedOpacity(index, value));

    // todo 多要素 specifiedAlpha

    const idx = specifiedAlpha.value.findIndex(item => item.index === index);
    if (value !== 1) {
      if (idx !== -1) specifiedAlpha.value[idx].alpha = value;
      else specifiedAlpha.value.push({ index, alpha: value });
    } else
      if (idx !== -1) specifiedAlpha.value.splice(idx, 1);
  }
};

// 生成颜色阈值工具
const generateColorThresholder = (index: number, colorCodeData: { [key: string]: string }, unit: string) => {
  const colorKeyObj = Object.keys(colorCodeData).sort((a, b) => parseFloat(a) - parseFloat(b));
  const colorLength = colorKeyObj.length;
  const canvas = document.getElementById(index === -1 ? "mode-compare-map-color" : ("mode-compare-map-" + index + "-color")) as HTMLCanvasElement;
  const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;

  if (index === -1 || displayStatus.value === "multiElement") {
    const gradient = ctx.createLinearGradient(0, 0, 0, 360);
    [...colorKeyObj].reverse().forEach((key, i) => {
      gradient.addColorStop(i / (colorLength - 1), colorCodeData[key]);
    });
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 20, 360);
  } else {
    const gradient = ctx.createLinearGradient(0, 0, 360, 0);
    colorKeyObj.forEach((key, i) => {
      gradient.addColorStop(i / (colorLength - 1), colorCodeData[key]);
    });
    ctx.fillStyle = gradient;
    ctx.fillRect(0, 0, 360, 20);
  }

  const mappingFunc = (val: number) => {
    const floorIndex = Math.floor(val / 10), ceilIndex = Math.ceil(val / 10);
    return parseFloat(colorKeyObj[floorIndex]) + (parseFloat(colorKeyObj[ceilIndex]) - parseFloat(colorKeyObj[floorIndex])) * (val - floorIndex * 10) / 10;
  };

  const colorThresholderParams = {
    threshold: parseFloat(colorKeyObj[0]), length: colorLength, valueList: Object.keys(colorCodeData).sort((a, b) => parseFloat(a) - parseFloat(b)),
    mappingFunc, mappingFuncWithUnit: (val: number) => { return parseFloat(mappingFunc(val).toFixed(3)) + unit }
  };

  if (index === -1) colorThresholder.value = colorThresholderParams;
  else newMapList.value[index].colorThresholder = colorThresholderParams;
}

/** 绘制差值纹理图 */
const drawDiffTexture = (index: number, markerLabel: string, customLayerList: CustomLayer[]) => {
  const gridData1 = customLayerList[0].image!.getGridData(), gridData2 = customLayerList[1].image!.getGridData();
  const gridDataDiff: number[] = [];
  gridData1.forEach((num, index) => gridDataDiff.push(parseFloat((num - gridData2[index]).toFixed(2))));

  const minValue = -Math.max(customLayerList[0].image!.maxValue, customLayerList[1].image!.maxValue),
    maxValue = Math.max(customLayerList[0].image!.maxValue, customLayerList[1].image!.maxValue), digits = 2, scale = 100;

  const imageInfo = customLayerList[0].image!;
  const gridImageData: number[] = new Array(imageInfo.gridWidth * imageInfo.gridHeight * 4).fill(0);

  let maxDiffAbs = 0;
  gridDataDiff.forEach((num, gridIndex) => {
    const tempNum = (num - minValue) * scale;
    if (Math.abs(num) > maxDiffAbs) maxDiffAbs = Math.abs(num);

    const r = Math.floor(tempNum / 256 / 256);
    const g = Math.floor((tempNum - r * 256 * 256) / 256);
    const b = tempNum - r * 256 * 256 - g * 256;
    const rowIndex = (imageInfo.gridHeight - 1) - Math.floor(gridIndex / imageInfo.gridWidth), colIndex = gridIndex % imageInfo.gridWidth;
    const index = (rowIndex * imageInfo.gridWidth + colIndex) * 4;

    gridImageData[index] = r, gridImageData[index + 1] = g, gridImageData[index + 2] = b, gridImageData[index + 3] = 255;
  });

  const colorCode: { [key: number]: string } = {};
  const colorList = ["#993301", "#ff3333", "#fd8784", "#ffdca8", "#fcfe9c", "#dfffd9", "#f2ffff", "#97fff4", "#3ca0f0", "#1a5ca6", "#80007c"]
  const colorInterval = maxDiffAbs / 10;
  for (let i = -5; i <= 5; i++)
    colorCode[i * colorInterval] = colorList[i + 5];

  const grayImage = new GrayImageByValue(
    {
      startLat: imageInfo.startLat, startLon: imageInfo.startLon, endLat: imageInfo.endLat, endLon: imageInfo.endLon,
      latInterval: imageInfo.yInterval, lonInterval: imageInfo.xInterval, latLength: imageInfo.gridHeight, lonLength: imageInfo.gridWidth
    },
    new ImageData(new Uint8ClampedArray(gridImageData), imageInfo.gridWidth, imageInfo.gridHeight),
    scale, digits, colorCode, minValue, maxValue, false
  );

  const customLayer = new CustomLayer(grayImage as any, "IntelligentGridLayer", "IntelligentGrid", [2, 3], () => { }, {}, true);
  newMapList.value[index].map.addLayer(customLayer, "world_line");
  newMapList.value[index].layer = customLayer;
  newMapList.value[index].markerInfo = {
    ...newMapList.value[index].markerInfo, markerLabel, unit: customLayerList[0].image?.dataUnit, gridData: gridDataDiff, borderInfo: {
      startLon: grayImage.startLon, endLon: grayImage.endLon, startLat: grayImage.startLat, endLat: grayImage.endLat,
      xInterval: grayImage.xInterval, yInterval: grayImage.yInterval, gridWidth: grayImage.gridWidth
    }
  };
  newMapList.value[index].map.on('mousemove', mousemoveEvent);
  if (customLayer.image) generateColorThresholder(-1, customLayer.image.colorCodeData, customLayerList[0].image!.dataUnit);
};

/** 鼠标移动监听事件(用于marker) */
const mousemoveEvent = (e: mapboxgl.MapMouseEvent & mapboxgl.EventData) => {
  newMapList.value.forEach((item) => {
    if (item.markerInfo.marker && item.markerInfo.borderInfo && item.markerInfo.gridData && item.markerInfo.markerDiv) {
      const border = item.markerInfo.borderInfo;
      if (e.lngLat.lng < border.startLon || e.lngLat.lng > border.endLon || e.lngLat.lat < border.startLat || e.lngLat.lat > border.endLat) {
        item.markerInfo.marker.remove();
        return;
      }

      const lonIndex = Math.round((e.lngLat.lng - border.startLon) / border.xInterval),
        latIndex = Math.round((e.lngLat.lat - border.startLat) / border.yInterval);
      item.markerInfo.markerDiv.innerText = item.markerInfo.markerLabel + "\n" +
        item.markerInfo.gridData[latIndex * border.gridWidth + lonIndex].toFixed(2) + item.markerInfo.unit;
      item.markerInfo.marker.setLngLat([e.lngLat.lng, e.lngLat.lat]);
      item.markerInfo.marker.addTo(item.map); /* Ensure the marker is added to the map. This is safe to call if it's already added. */
    }
  });
};

/** 
 * 指定地图绘制3D
 * @param index 地图索引
 * @param url 纹理图 (不传则清空)
 */
const ThreeModel = ref(); // 三维模型
const threeModelOperation = ref<ThreeModelOperation>();
const draw3D = (index: number, url?: string) => {
  if (url) {
    const texImage = new Image();
    texImage.src = url;
    texImage.setAttribute('crossOrigin', '');
    try {
      texImage.onload = () => {
        const image = new GrayImage(GetBytesFromImage(texImage));
        if (ThreeModel.value) ThreeModel.value.updateUrl(image);
        else {
          ThreeModel.value = new ClassThreeTextureModel(image);
          newMapList.value[index].map.addLayer(ThreeModel.value.TextureCustomLayer);
        }

        // 操作变量赋值
        const St_Lat = image.startLat, St_Lon = image.startLon, End_Lat = image.endLat, End_Lon = image.endLon;
        threeModelOperation.value = {
          St_Lat, St_Lon, End_Lat, End_Lon,
          xySectionInfo: { xMin: St_Lon, xMax: End_Lon, yMin: St_Lat, yMax: End_Lat },
          xSectionVal: [parseFloat(St_Lon.toFixed(2)), parseFloat(End_Lon.toFixed(2))],
          ySectionVal: [parseFloat(St_Lat.toFixed(2)), parseFloat(End_Lat.toFixed(2))],
          zSectionVal: [0, image.altitudeHPa[image.altitudeHPa.length - 1]],
          atmosphereInfo: { min: image.altitudeHPa[0], max: image.altitudeHPa[image.altitudeHPa.length - 1] },
          thresholdInfo: { min: Math.floor(image.minValue), max: Math.ceil(image.maxValue) },
          thresholdVal: Math.floor(image.minValue),
          opacityVal: 0.5
        };
        ThreeModel.value.setThreshold(threeModelOperation.value.thresholdVal);
      };
    } catch (excepiton) {
      ElMessage.error("加载纹理图失败 " + excepiton);
    }
  }
};

/** 调整阈值 */
const changeThreshold = (index: number, value: number) => {
  if (index === -1) {
    const threshold = colorThresholder.value!.mappingFunc(value);
    if (displayStatus.value !== "difference")
      newMapList.value.forEach((item) => {
        if (item.layer) item.layer.changeThreshold(threshold);
      });
    else {
      const diffLayer = newMapList.value[newMapList.value.length - 1].layer;
      if (diffLayer) diffLayer.changeThreshold(threshold);
    }
  }
  else
    if (newMapList.value[index].colorThresholder && newMapList.value[index].layer) {
      const threshold = newMapList.value[index].colorThresholder!.mappingFunc(value);
      newMapList.value[index].layer?.changeThreshold(threshold);
    }
};

/** 以下为三维面板处理方法 */
// 调整X轴截面
const changeXSectionVal = (val: [number, number]) => {
  if (threeModelOperation.value) {
    ThreeModel.value.setProps("xClippingPlaneMin",
      (val[0] - threeModelOperation.value.xySectionInfo.xMin) /
      (threeModelOperation.value.xySectionInfo.xMax - threeModelOperation.value.xySectionInfo.xMin));
    ThreeModel.value.setProps("xClippingPlaneMax",
      (val[1] - threeModelOperation.value.xySectionInfo.xMin) /
      (threeModelOperation.value.xySectionInfo.xMax - threeModelOperation.value.xySectionInfo.xMin));
  }
};

// 调整Y轴截面
const changeYSectionVal = (val: [number, number]) => {
  if (threeModelOperation.value) {
    ThreeModel.value.setProps("zClippingPlaneMax",
      1 - (val[0] - threeModelOperation.value.xySectionInfo.yMin) /
      (threeModelOperation.value.xySectionInfo.yMax - threeModelOperation.value.xySectionInfo.yMin));
    ThreeModel.value.setProps("zClippingPlaneMin",
      1 - (val[1] - threeModelOperation.value.xySectionInfo.yMin) /
      (threeModelOperation.value.xySectionInfo.yMax - threeModelOperation.value.xySectionInfo.yMin));
  }
};

// 调整Z轴截面
const changeZSectionVal = (val: [number, number]) => {
  if (threeModelOperation.value) {
    const drawHeight = ThreeModel.value.guiControls.drawHeight;
    const bottomHeight = atmosphericPressure_to_height(
      threeModelOperation.value.atmosphereInfo.max - val[0] + threeModelOperation.value.atmosphereInfo.min
    );
    const topHeight = atmosphericPressure_to_height(
      threeModelOperation.value.atmosphereInfo.max - val[1] + threeModelOperation.value.atmosphereInfo.min
    );
    ThreeModel.value.setProps("yClippingPlaneMin", bottomHeight / drawHeight);
    ThreeModel.value.setProps("yClippingPlaneMax", topHeight / drawHeight);
  }
};

// 绘制截面/截取区域/单点
const drawHandle = (mode: string) => {
  mapboxDraw.value?.changeMode(mode);
};

// 清除绘制
const trashHandle = () => {
  mapboxDraw.value?.trash();
};

// 调整阈值
const change3DThreshold = (val: number) => {
  if (ThreeModel.value && ThreeModel.value.setThreshold)
    ThreeModel.value.setThreshold(val);
};

// 调整透明度
const changeOpacity = (val: number) => {
  ThreeModel.value.setOpacity(val);
};

// 切换高度层
const changeLevel = (index: number) => {
  const level = newMapList.value[index].level;
  const heightIndex = heightOption.value.length - 1 - heightOption.value.findIndex((height: number) => height === level);
  const newColorCode = newMapList.value[index].layer?.changeLevelIndex(heightIndex);
  if (newColorCode)
    generateColorThresholder(index, newColorCode, newMapList.value[index].layer?.image?.dataUnit!);
};

// 切换高度截面
const switchHeightCutting = () => {
  isHeightCutting.value = !isHeightCutting.value;
  if (isHeightCutting.value) ThreeModel.value.switchHeightCutting(2, 1000, 15000, 1500);
  else ThreeModel.value.switchHeightCutting(0, 0, 0, 0);
};
</script>

<style scoped lang="scss">
@import "./ModeCompare.scss";
@import "@/assets/sass/element.scss";
</style>
<style lang="scss">
.mode-compare-map-box {
  .mapboxgl-canvas-container {
    >canvas {
      margin-left: 0;
      transition: 0.3s;
    }
  }
}

.ModeCompareMapMarker {
  position: absolute;
  padding: 3px 4px;
  background-color: white;
  color: black;
  box-shadow: 0 0 4px #00000080;
  border-radius: 5px;
  min-width: 70px;
  text-align: center;
}
</style>